import { axiosInstance } from "./axios";

// Get all bookmarks
export const getBookmarks = async (userId) => {
  try {
    const res = await axiosInstance.post("/bookmark/list", {
      user_id: userId,
    });
    const bookmarks = res?.data?.data || [];
    return bookmarks.map((item) => ({ ...item, bookmarked: 1 }));
  } catch (error) {
    console.error("Error fetching bookmarks:", error);
    return [];
  }
};

// Toggle bookmark (ADD / REMOVE) — just the API call
export const toggleBookmarkAPI = async ({ userId, jobId, alreadyBookmarked }) => {
  const status = alreadyBookmarked ? 0 : 1;

  try {
    const payload = {
      status,
      user_id: userId,
      data_id: jobId,
    };

    const res = await axiosInstance.post("/bookmark", payload);
    return res?.data;
  } catch (error) {
    console.error("Error toggling bookmark:", error);
    throw error;
  }
};
